import { normalizeIcd10Key } from '@seen/core/models/organizationConditionsList'
import { orderBy } from 'lodash-es'
import { rowIcd10Codes } from '#src/components/condition-picker/rowIcd10Codes.ts'
import type { ConditionPickerCondition } from '#src/components/condition-picker/types.ts'

// An ICD-10-CM category is a letter, a digit, then a letter or digit (H90,
// C4A). That shape distinguishes a code search from a title search once the
// dots are stripped. "HEADACHE" normalizes to letters only and is left to
// Fuse's title ranking.
const CODE_QUERY = /^[A-Z]\d[A-Z\d]/

function codeMatchRank(codes: string[], query: string): number {
  if (codes.includes(query)) {
    return 0
  }
  if (codes.some((code) => code.startsWith(query))) {
    return 1
  }
  return 2
}

// The picker builds its additions as fuzzy catalog matches followed by the
// official ICD-10 expansion, and Fuse's scores are dropped on the way, so a
// search naming one code exactly can land below every loose title match. Sort
// code searches by how directly each row answers the code. lodash keeps the
// sort stable, so rows of equal rank hold the order they arrived in.
export function rankConditionAdditions(
  additions: ConditionPickerCondition[],
  search: string
): ConditionPickerCondition[] {
  const query = normalizeIcd10Key(search)
  if (!CODE_QUERY.test(query)) {
    return additions
  }
  return orderBy(
    additions,
    [(condition) => codeMatchRank(rowIcd10Codes(condition), query)],
    ['asc']
  )
}
